import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  // padding: (p) => p.spacing(6, 4, 2, 4),
  gap: (p) => p.spacing(1.5),
  width: '100%',
};
